import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { UserManagementTable } from '@redpanda/ui';
import { formatTableDate } from '@redpanda/utils';
import { UserContext } from '../context/UserContext';
import { getApprovedUsers, getPendingUsers, updateUserRole, deleteUser, approveUser, rejectUser } from '../services/api';
import PageContainer from '../components/PageContainer';
import PageTitle from '../components/PageTitle';

// 使用者管理表（@redpanda/ui 共用，R26，同 CRM）呼叫的 API
const userManagementApi = { getApprovedUsers, getPendingUsers, updateUserRole, deleteUser, approveUser, rejectUser };

const AdminPage: React.FC = () => {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);
  // user 物件要等 checkAuthStatus() 打完 API 才有值，重新整理時會有一段空窗；
  // cachedUserRole 跟 isAuthenticated 一樣是從 localStorage 同步讀出來的，重新整理當下就有值，
  // 用它當 fallback 可以避免這段空窗期間誤判成「無權限」而閃爍
  const userRole = userContext?.user?.role ?? userContext?.cachedUserRole;
  const currentUser = userContext?.user
    ?? (userContext?.cachedUserId ? { id: userContext.cachedUserId, role: userContext.cachedUserRole ?? undefined } : null);

  if (userRole !== 'SUPER_ADMIN') {
    return (
      <PageContainer>
        <div className="text-center py-12">
          <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-4">{t('common.messages.unauthorized')}</h1>
          <p className="text-[var(--text-secondary)]">{t('auth.permission_denied_account_portal')}</p>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageTitle title={t('admin.title')} />
      <UserManagementTable api={userManagementApi} currentUser={currentUser} formatDate={formatTableDate} />
    </PageContainer>
  );
};

export default AdminPage;
